<template>
  <router-view />
</template>

<script>
import distributors from 'store/distributors.store';
import view from 'store/view.store';
import exportBases from 'store/exportBases.store';
import channel from 'store/channel.store';
import plan from 'store/plan.store';
import duplicateActivation from 'store/duplicateActivation.store';
import logsImportHistory from 'store/logsImportHistory.store';

import statusChip from 'store/statusChip.store';

const DISTRIBUTORS_STORE = 'distributors';
const VIEW_STORE = 'view';
const EXPORT_BASES_STORE = 'exportBases';
const CHANNELS_STORE = 'channel';
const PLANS_STORE = 'plan';
const DUPLICATE_ACTIVATION = 'duplicateActivation';

const IMPORT_PROCESS_HISTORY = 'logsImportHistory';

const STATUS_CHIP = 'statusChip';

export default {
  beforeCreate() {
    this.$store.registerModule(DISTRIBUTORS_STORE, distributors);
    this.$store.registerModule(VIEW_STORE, view);
    this.$store.registerModule(EXPORT_BASES_STORE, exportBases);
    this.$store.registerModule(CHANNELS_STORE, channel);
    this.$store.registerModule(PLANS_STORE, plan);
    this.$store.registerModule(DUPLICATE_ACTIVATION, duplicateActivation);
    this.$store.registerModule(IMPORT_PROCESS_HISTORY, logsImportHistory);
    this.$store.registerModule(STATUS_CHIP, statusChip);
  },
  beforeDestroy() {
    this.$store.unregisterModule(DISTRIBUTORS_STORE);
    this.$store.unregisterModule(VIEW_STORE);
    this.$store.unregisterModule(EXPORT_BASES_STORE);
    this.$store.unregisterModule(CHANNELS_STORE);
    this.$store.unregisterModule(PLANS_STORE);
    this.$store.unregisterModule(DUPLICATE_ACTIVATION);
    this.$store.unregisterModule(IMPORT_PROCESS_HISTORY);
    this.$store.unregisterModule(STATUS_CHIP);
  }
};
</script>
